const buttonFade = (delay = 0) => ({
  hidden: {
    translateY: 50,
    opacity: 0
  },
  enter: {
    translateY: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeInOut",
      delay: 0.5 + delay
    }
  },
  exit: {
    translateY: -50,
    opacity: 0,
    transition: {
      duration: 0.25,
      ease: "easeInOut",
      delay: delay
    }
  }
});

export default buttonFade;

export const buttonFadeIn = (delay = 0) => ({
  hidden: {
    translateY: 50,
    opacity: 0
  },
  enter: {
    translateY: 0,
    opacity: 1,
    transition: {
      duration: 1,
      ease: "easeInOut",
      delay: 0.5 + delay
    }
  },
  exit: {
    translateY: -50,
    opacity: 0,
    transition: {
      duration: 0.25,
      ease: "easeInOut",
      delay: 0.25 + delay
    }
  }
});
